<template>
  <div>
    <PageTitleVue :sub-title="'Emita relatórios de visitas técnicas de modo descomplicado'"> 
      RELATÓRIOS 
    </PageTitleVue>

    <section>
      <div
        class="relative overflow-hidden shadow-sm sm:rounded-2xl min-h-[50vh] p-4 bg-white border border-gray-100"
      >
        <TabWithIcon
          :tabs="tabs"
          :active-tab="activeTab"
          @change="setActiveTab"
        />

        <div class="pt-5">
          <KeepAlive>
            <component :is="activeComponent" />
          </KeepAlive>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, markRaw, ref } from "vue";
import PageTitleVue from "@/components/Titles/PageTitle.vue";

import TabWithIcon from "./components/tabs/TabWithIcon.vue";
import RecentReportsTab from "./components/tabs/RecentReportsTab.vue";
import ReportVisitClientsTab from "./components/tabs/ReportVisitClientsTab.vue";
import ReportLayoutsTab from "./components/tabs/ReportLayoutsTab.vue";

import {
  PhClockCounterClockwise,
  PhBuildings,
  PhSlidersHorizontal,
} from "@phosphor-icons/vue";

const activeTab = ref("recent");

const tabs = [
  {
    key: "recent",
    label: "Recentes",
    icon: markRaw(PhClockCounterClockwise),
    description: "Histórico de relatórios emitidos",
  },
  {
    key: "clients",
    label: "Empresas",
    icon: markRaw(PhBuildings),
    description: "Clientes visitados",
  },
  {
    key: "layouts",
    label: "Layouts",
    icon: markRaw(PhSlidersHorizontal),
    description: "Modelos personalizados",
  },
];

const components = {
  recent: markRaw(RecentReportsTab),
  clients: markRaw(ReportVisitClientsTab),
  layouts: markRaw(ReportLayoutsTab),
};

const activeComponent = computed(() => {
  return components[activeTab.value] || RecentReportsTab;
});

function setActiveTab(tabKey) {
  activeTab.value = tabKey;
}
</script>